import { fetchBuildings, fetchBuilding, removeBuilding, fetchBuildingsEntrances } from '../repositories/building.repository'

const state = {
    buildings: [],
    buildingsEntrances: [],
    building: null
}

const actions = {
    fetchBuildings ({ commit }, fields = null) {
        return new Promise(resolve => fetchBuildings(fields)
            .then(res => {
                commit('setBuildings', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchBuilding ({ commit }, id) {
        return new Promise(resolve => fetchBuilding(id)
            .then(res => {
                commit('setBuilding', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchBuildingsEntrances ({ commit }, fields = null) {
        return new Promise(resolve => fetchBuildingsEntrances(fields)
            .then(res => {
                commit('setBuildingsEntrances', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    /* eslint-disable no-unused-vars */
    removeBuilding ({ dispatch }, id) {
        return removeBuilding(id)
    }
}

const mutations = {
    setBuildings (state, buildings) {
        state.buildings = buildings
    },
    setBuilding (state, building) {
        state.building = building
    },
    setBuildingsEntrances (state, buildings) {
        state.buildingsEntrances = buildings
    },
}

const getters = {
    getBuilding (state) {
        return id => {
            return state.buildings.filter(building => building.id === id)[0]
        }
    }
}

export default {
    state,
    actions,
    getters,
    mutations
}